const cookies = {
  message: `<div align="justify">
  <p>
    <b>GLOSPEN, SL</b> utilitza
    <b><i>&quot;COOKIES&quot;</i></b>
    per garantir el correcte funcionament del nostre portal web,
    millorant la seguretat, per obtenir una eficàcia i una personalització superiors, per recollir dades
    estadístiques i per mostrar-li publicitat rellevant.
  </p>
  <p>
    Si continua navegant o premeu el botó
    <b>&quot;ACEPTAR&quot;</b> considerarem que accepta tot el seu ús.
    Podeu obtenir més informació a la nostra
    <a
    href="/cookies/ca"
    target="_blank"
    >POLÍTICA DE COOKIES</a>
    a peu de pàgina.
  </p>
</div>`,
  content: `<ol>
  <div>
    <li class="body-2 font-weight-bold pb-2">QUÈ SÓN LES COOKIES ?</li>
    <p style="text-align: justify" class="body-1">
      Les cookies són petits arxius de dades que es reben en el terminal des del lloc web visitat i
      s&#39;usen per registrar certes interaccions de la navegació en un lloc web emmagatzemant dades
      que podran ser actualitzats i recuperats. Aquests arxius s&#39;emmagatzemen a l&#39;ordinador de
      l&#39;usuari i conté dades anònims que no són perjudicials per al seu equip. S&#39;utilitzen per recordar
      les preferències de l&#39;usuari, com l&#39;idioma seleccionat, dades d&#39;accés o personalització de la
      pàgina.
    </p>
    <p style="text-align: justify" class="body-1">
      Les cookies també poden ser utilitzades per registrar informació anònima sobre com un visitant
      utilitza un lloc. Per exemple, des de quina pàgina web ha accedit, o si ha utilitzat un &quot;banner&quot;
      publicitari per arribar.
    </p>
  </div>
  <div>
    <li class="body-2 font-weight-bold pb-2">PER QUÈ UTILITZEM COOKIES ?</li>
    <p style="text-align: justify" class="body-1">
      <b>GLOSPEN, SL</b> utilitza cookies estrictament necessàries i essencials perquè utilitzeu els nostres
      llocs web i li permetin moure lliurement, utilitzar àrees segures, opcions personalitzades, etc. A
      més,
      <b>GLOSPEN, SL</b> utilitza cookies que recullen dades relatives a l&#39;anàlisi d&#39;ús de la web.
      Aquestes s&#39;utilitzen per ajudar a millorar el servei al client, mesurant l&#39;ús i el rendiment de la
      pàgina, per optimitzar-la i personalitzar-la.
    </p>
    <p style="text-align: justify" class="body-1">
      Els nostres llocs també poden tenir enllaços de xarxes socials (com Facebook o Twitter).
      <b>GLOSPEN, SL</b> no controla les cookies utilitzades per aquestes webs externes. Per a més
      informació sobre les cookies de les xarxes socials o altres Webs alienes, aconsellem revisar les
      seves pròpies polítiques de cookies.
    </p>
    <p
      style="text-align: justify"
      class="body-1"
    >Aquest lloc web utilitza &quot;cookies&quot; de la següent manera:</p>
    <ul class="mb-3">
      <li style="text-align: justify" class="my-2">
        <b>Cookie de Google ANALYTICS:</b> Google ANALYTICS és un servei gratuït que ofereix
        Google Inc. i que recull informació sobre les pàgines de la web consultada, a quina hora,
        quin navegador Web, etc. Posteriorment, aquesta informació s&#39;envia als servidors de
        Google Inc. als Estats Units.
      </li>
      <li style="text-align: justify" class="my-2">
        <b>Cookies d’aplicació “Add-this”:</b> Add-this és un servei gratuït que li permet compartir
        pàgines d&#39;aquest lloc web per diferents mitjans (correu electrònic, xarxes socials, etc.). Add-
        this compila informació estadística de la vostra navegació per proporcionar publicitat
        adaptada als seus hàbits de navegació en aquest lloc web o en qualsevol altre lloc.
      </li>
    </ul>
  </div>
  <div>
    <li
      class="body-2 font-weight-bold pb-2"
    >QUIN ÚS LI DONEM ALS DIFERENTS TIPUS DE COOKIES ?</li>
    <div class="body-2 font-weight-bold pb-2">Segons la seva finalitat:</div>
    <ul class="mb-3">
      <li style="text-align: justify" class="my-2">
        <b>Cookies tècniques:</b> Les cookies tècniques són aquelles imprescindibles i estrictament
        necessàries per al correcte funcionament d&#39;un portal web i la utilització de les diferents opcions
        i serveis que ofereix. Por exemple, les que serveixen per al manteniment de la sessió, la gestió
        del temps de resposta, rendiment o validació d&#39;opcions, utilitzar elements de seguretat,
        compartir contingut amb xarxes socials, etc.
      </li>
      <li style="text-align: justify" class="my-2">
        <b>Cookies de personalització:</b> Aquestes cookies permeten a l&#39;usuari especificar o
        personalitzar algunes característiques de les opcions generals de la pàgina web, per exemple,
        definir l&#39;idioma, configuració regional o tipus de navegador.
      </li>
      <li style="text-align: justify" class="my-2">
        <b>Cookies analítiques:</b> Les cookies analítiques són les utilitzades pel nostre portal web, per
        elaborar perfils de navegació i poder conèixer les preferències dels usuaris del mateix per tal de
        millorar l&#39;oferta de productes i serveis. Per exemple, mitjançant una galeta analítica es
        controlarien les àrees geogràfiques de major interès d&#39;un usuari, quin és el producte de més
        acceptació, etc.
      </li>
      <li style="text-align: justify" class="my-2">
        <b>Cookies publicitàries / de publicitat:</b> Les cookies publicitàries permeten la gestió dels
        espais publicitaris en base a criteris concrets. Per exemple la freqüència d&#39;accés, el contingut
        editat, etc. Les cookies de publicitat permeten a través de la gestió de la publicitat
        emmagatzemar informació del comportament a través de l&#39;observació d&#39;hàbits, estudiant els
        accessos i formant un perfil de preferències de l&#39;usuari, per oferir publicitat relacionada amb els
        interessos del seu perfil.
      </li>
    </ul>
    <div class="body-2 font-weight-bold pb-2">Segons termini:</div>
    <ul class="mb-3">
      <li style="text-align: justify" class="my-2">
        <b>Cookies de sessió:</b> Les cookies de sessió són aquelles que duren el temps que l&#39;usuari està
        navegant per la pàgina web i s&#39;esborren al terme.
      </li>
      <li style="text-align: justify" class="my-2">
        <b>Cookies persistents:</b> Aquestes cookies queden emmagatzemades en el terminal de l&#39;usuari,
        per un temps més llarg, facilitant així el control de les preferències triades sense haver de
        repetir certs paràmetres cada vegada que es visiti el lloc web.
      </li>
    </ul>
  </div>
  <div>
    <li
      class="body-2 font-weight-bold pb-2"
    >I SI NO VULL TENIR AQUESTES COOKIES O NO FAIG RES AL RESPECTE ?</li>
    <p style="text-align: justify" class="body-1">
      Per complir amb la legislació vigent, hem de demanar el seu permís per gestionar cookies. Si
      decideix no autoritzar el tractament indicant la no conformitat, només utilitzaríem les cookies
      tècniques, ja que són imprescindibles per a la navegació per la nostra web. En aquest cas, no
      emmagatzemaríem cap galeta. En el cas de seguir navegant pel nostre lloc web sense denegar
      la seva autorització implica que accepta el seu ús.
    </p>
    <p style="text-align: justify" class="body-1">
      Tingueu en compte que si rebutja o esborra les cookies de navegació per la Web, no podrem
      mantenir les seves preferències, algunes característiques de les pàgines no estaran operatives,
      no podrem oferir-li serveis personalitzats i cada vegada que vagi a navegar per la nostra web
      haurem de sol·licitar de nou la seva autorització per a l&#39;ús de cookies.
    </p>
    <p style="text-align: justify" class="body-1">
      Si tot i així, decideix modificar la configuració del seu accés a la pàgina web, ha de saber que
      és possible eliminar les cookies o impedir que es registri aquesta informació en el seu equip en
      qualsevol moment mitjançant la modificació dels paràmetres de configuració del seu
      navegador:
    </p>

    <ul class="mb-3">
      <li style="text-align: justify" class="my-2">
        <a
          target="_blank"
          href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies"
        >Configuració de cookies de Internet Explorer.</a>
      </li>
      <li style="text-align: justify" class="my-2">
        <a
          target="_blank"
          href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"
        >Configuració de cookies de Firefox.</a>
      </li>
      <li style="text-align: justify" class="my-2">
        <a
          target="_blank"
          href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&amp;hl=es-419"
        >Configuració de cookies de Google Chrome.</a>
      </li>
      <li style="text-align: justify" class="my-2">
        <a
          target="_blank"
          href="https://support.apple.com/es-es/guide/safari/sfri11471/mac"
        >Configuració de cookies de Safari.</a>
      </li>
    </ul>
    <p style="text-align: justify" class="body-1">
      Aquests navegadors estan sotmesos a actualitzacions o modificacions, pel que no podem
      garantir que s&#39;ajustin completament a la versió del seu navegador. També pot ser que utilitzi un
      altre navegador no contemplat en aquests enllaços com ara Konqueror, Arora, Flock, etc. Per
      evitar aquests desajustos, pot accedir directament des de les opcions del seu navegador que
      es troba generalment al menú d&#39;Opcions, a la secció de &quot;Privacitat&quot;. (Si us plau, consulteu
      l&#39;ajuda del seu navegador per a més informació.)
    </p>
  </div>
  <div>
    <li class="body-2 font-weight-bold pb-2">ON PUC OBTENIR MÉS INFORMACIÓ ?</li>
    <p
      style="text-align: justify"
      class="body-1"
    >Pots trobar més informació sobre cookies a:</p>

    <a target="_blank" href="https://www.allaboutcookies.org">www.allaboutcookies.org</a> o
    <a
      target="_blank"
      href="https://www.youronlinechoices.eu"
    >www.youronlinechoices.eu.</a>
  </div>
</ol>`,
}
export default cookies
